'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var sortByPivotHour = function sortByPivotHour(hours) {
  return hours.sort(function (a, b) {
    return a.pivotHour > b.pivotHour ? 1 : b.pivotHour > a.pivotHour ? -1 : 0;
  });
};
var sortInLowerCase = function sortInLowerCase(items) {
  return items.sort(function (a, b) {
    return a.toLowerCase() > b.toLowerCase() ? 1 : b.toLowerCase() > a.toLowerCase() ? -1 : 0;
  });
};
var getUpdatedWorkshopInfo = function getUpdatedWorkshopInfo(currentInfo, newWorkshop, props) {
  var entities = props.entities,
    otherData = props.otherData;
  var event = entities.events[Object.keys(entities.events)[0]];
  var timezone = (0, _moment2.default)(newWorkshop.endDate);
  if (otherData.useEventTimezone) timezone.tz(event.virtualTimezone);
  var stringTz = timezone.format(' [GMT]ZZ');
  var sortDates = function sortDates(dates) {
    var sortedDates = {};
    for (var datestamp in dates) {
      var _dates$datestamp = dates[datestamp],
        hours = _dates$datestamp.hours,
        other = _objectWithoutProperties(_dates$datestamp, ['hours']);
      var sortedHours = sortByPivotHour(hours);
      sortedDates[datestamp] = _extends({
        hours: sortedHours
      }, other);
    }
    return sortedDates;
  };
  var getHours = function getHours(start, end, location) {
    var startHour = start ? start.format('HH:mm' + (!end ? stringTz : '')) : start;
    var endHour = end ? end.format('HH:mm') + stringTz : end;
    var pivotHour = Math.min(start ? parseInt(start.format('HHmm')) : Number.MAX_SAFE_INTEGER, end ? parseInt(end.format('HHmm')) : Number.MAX_SAFE_INTEGER);
    return {
      startHour: startHour,
      endHour: endHour,
      location: location,
      pivotHour: pivotHour
    };
  };
  var currentDates = currentInfo.dates || {};
  var newStartDate = (0, _moment2.default)(newWorkshop.startDate);
  var newEndDate = (0, _moment2.default)(newWorkshop.endDate);
  // Add day info
  if (!currentDates.hasOwnProperty(newStartDate.format('YYYYMMDD'))) {
    currentDates[newStartDate.format('YYYYMMDD')] = {
      dayOfWeek: newStartDate.format('dddd'),
      month: newStartDate.format('MMMM'),
      dayOfMonth: newStartDate.format('D'),
      hours: []
    };
  }
  if (!currentDates.hasOwnProperty(newEndDate.format('YYYYMMDD'))) {
    currentDates[newEndDate.format('YYYYMMDD')] = {
      dayOfWeek: newEndDate.format('dddd'),
      month: newEndDate.format('MMMM'),
      dayOfMonth: newEndDate.format('D'),
      hours: []
    };
  }
  var startDateStamp = newStartDate.format('YYYYMMDD');
  var endDateStamp = newEndDate.format('YYYYMMDD');
  var location = newWorkshop.location;

  // Add hours
  if (startDateStamp === endDateStamp) {
    var newHour = getHours(newStartDate, newEndDate, location);
    var currentHours = currentDates[endDateStamp]["hours"];
    currentDates[endDateStamp]["hours"].push(newHour);
  } else {
    var newStartHour = getHours(newStartDate, undefined, location);
    var newEndHour = getHours(undefined, newEndDate, location);
    var currentStartHours = currentDates[startDateStamp]["hours"];
    var currentEndHours = currentDates[endDateStamp]["hours"];
    currentDates[startDateStamp]["hours"].push(newStartHour);
    currentDates[endDateStamp]["hours"].push(newEndHour);
  }
  var sortedDates = sortDates(currentDates);
  return {
    name: newWorkshop.name,
    description: currentInfo.description || newWorkshop.description,
    dates: sortedDates,
    workshopCategories: newWorkshop.workshopCategories
  };
};
var separateByName = function separateByName(props) {
  var workshops = props.entities.workshops;
  if (!workshops) return {};
  var byName = {};
  if (!Array.isArray(workshops)) {
    workshops = Object.keys(workshops).map(function (k) {
      return workshops[k];
    });
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = workshops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var workshop = _step.value;
      var name = workshop.name;
      if (!byName.hasOwnProperty(name)) byName[name] = {};
      byName[name] = getUpdatedWorkshopInfo(byName[name], workshop, props);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return byName;
};
var getSelectedDays = function getSelectedDays(byName) {
  if (!byName) return {};
  var selected = {};
  for (var name in byName) {
    selected[name] = Object.keys(byName[name].dates)[0];
  }
  return selected;
};
var deriveState = function deriveState(props) {
  var categories = props.entities.workshop_categories;
  var byName = props.entities.workshops && separateByName(props);
  var selectedDays = getSelectedDays(byName);
  var sortedNames = sortInLowerCase(Object.keys(byName || {}));
  return {
    byName: byName,
    sortedNames: sortedNames,
    selectedDays: selectedDays,
    categories: categories
  };
};
function manageWorkshopByNameState() {
  return function (WrappedComponent) {
    var Workshops = function (_Component) {
      _inherits(Workshops, _Component);
      function Workshops(props) {
        _classCallCheck(this, Workshops);
        var _this = _possibleConstructorReturn(this, (Workshops.__proto__ || Object.getPrototypeOf(Workshops)).call(this, props));
        _this.state = _extends({}, deriveState(props));
        return _this;
      }
      _createClass(Workshops, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          this.setState(deriveState(nextProps));
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state));
        }
      }]);
      return Workshops;
    }(_react.Component);
    return Workshops;
  };
}
exports.default = manageWorkshopByNameState;